<template>
  <v-select
    :options="paginated"
    :filterable="false"
    @search="fetchOptions"
    v-model="searchProduct"
    :placeholder="translations('common.jan_model_legacy')"
    label="name"
    @open="onOpen"
    @close="onClose"
  >
    <template #search="{ attributes, events }">
      <input
        class="vs__search"
        v-bind="attributes"
        v-on="events"
        v-model="innerValue"
      />
    </template>
    <span slot="no-options" class="px-3"> 対象商品在庫が見つかりません </span>
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">
        その他のオプションを読み込んでいます...
      </li>
    </template>
  </v-select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InOutSearch',
  props: {
    value: String
  },
  components: {},
  data () {
    return {
      observer: null,
      pageSearch: 1,
      totalPageSearch: -1,
      searchValue: '',
      innerValue: this.$storage.get('InOutSearch:searchProduct') || '',
      searchProductList: [],
      isSearching: false,
      page: 1
    }
  },
  mounted: function () {
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  updated: function () {
    if (this.$refs.load && this.hasNextPage) {
      this.$refs.load.offsetParent.addEventListener('scroll', this.onScroll)
    }
  },
  destroyed: function () {
    this.$refs.load.offsetParent.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    ...mapState(['currentLanguage']),
    searchProduct: {
      get () {
        return this.value
      },
      set (val) {
        this.innerValue = val
        this.$emit('input', val)
        this.$storage.set('InOutSearch:searchProduct', val) // KEEP KEYWORD
      }
    },
    paginated () {
      return this.searchProductList.filter((item, index) => {
        return this.searchProductList.indexOf(item) === index
      })
    },
    hasNextPage () {
      if (this.totalPageSearch === -1) return true
      if (this.searchProductList.length === 0) return false
      return this.pageSearch < this.totalPageSearch
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    fetchOptions (keyword, loading) {
      clearTimeout(this.timeOutId)
      if (keyword.length) {
        loading(true)
        this.timeOutId = setTimeout(() => {
          this.search(loading, keyword)
        }, 1000)
      } else {
        loading(false)
        this.search(loading, '')
      }
    },
    async search (loading, keyword) {
      this.pageSearch = 1
      this.searchValue = keyword
      let params = {
        page: this.pageSearch,
        product_code: keyword
      }
      try {
        let response = await this.$http.get(this.$api_url.products_list, {
          params
        })

        this.totalPageSearch = response.data.pagination.total_pages
        this.searchProductList = [].concat(
          response.data.data.map((item) =>
            [item.ean_code, item.model, item.legacy_code]
              .filter(Boolean)
              .join(' - ')
          )
        )
        loading(false)
      } catch (error) {}
    },
    async onOpen () {
      this.pageSearch = 1
      this.searchValue = ''
      let params = {
        page: this.pageSearch,
        product_code: this.searchValue
      }
      try {
        let response = await this.$http.get(this.$api_url.products_list, {
          params
        })
        this.totalPageSearch = response.data.pagination.total_pages
        this.searchProductList = response.data.data.map((item) =>
          [item.ean_code, item.model, item.legacy_code]
            .filter(Boolean)
            .join(' - ')
        )
      } catch (error) {}
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    async onScroll () {
      if (this.hasNextPage) {
        await this.$nextTick()
        if (this.$refs.load) {
          this.observer.observe(this.$refs.load)
        }
      }
    },
    onClose () {
      this.observer.disconnect()
      this.innerValue = this.$storage.get('InOutSearch:searchProduct') || ''
    },
    async infiniteScroll ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        let params = {
          page: ++this.pageSearch,
          product_code: this.searchValue
        }
        try {
          let response = await this.$http.get(this.$api_url.products_list, {
            params
          })
          this.totalPageSearch = response.data.pagination.total_pages
          this.searchProductList.push(
            ...response.data.data.map((item) =>
              [item.ean_code, item.model, item.legacy_code]
                .filter(Boolean)
                .join(' - ')
            )
          )
          this.$nextTick(() => {
            ul.scrollTop = scrollTop
          })
        } catch (error) {}
      }
    }
  }
}
</script>

<style>
.search-in-out .v-select.vs--single .vs__selected {
  display: none;
}
</style>
